import { gql } from '@apollo/client'

import { UNKNOWN_WORD_LIST_FRAGMENT } from '../fragments'

const UNKNOWN_WORDS_QUERY = gql`
  query unknownWordsQuery(
    $filters: UnknownWordFiltersInput!
    $pagination: PaginationInput!
    $sorters: UnknownWordSortersInput!
  ) {
    unknownWords(
      filters: $filters
      pagination: $pagination
      sorters: $sorters
    ) {
      total
      result {
        ...UnknownWordListFragment
      }
    }
  }
  ${UNKNOWN_WORD_LIST_FRAGMENT}
`

export default UNKNOWN_WORDS_QUERY
